import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  Paper,
  Checkbox,
  FormControlLabel,
  Grid,
  Divider,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SignupPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [interests, setInterests] = useState({
    basketball: false,
    football: false,
    baseball: false,
    boxes: false,
    deals: false,
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInterestChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInterests({
      ...interests,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    
    if (!email) {
      setError('Email is required');
      return;
    }
    
    if (!email.includes('@') || !email.includes('.')) {
      setError('Please enter a valid email address');
      return;
    }
    
    // In a real app, this would send data to a server
    console.log('Submitting:', { name, email, interests });
    setSubmitted(true);
    setError('');
  };

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Box sx={{ mb: 6, maxWidth: '800px', mx: 'auto', textAlign: 'center' }}>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
          Join the GOAT Cards Community
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign up for exclusive deals, new releases, and breaking news
        </Typography>
      </Box>

      <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 2 }}>
        {submitted ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h4" sx={{ mb: 2, color: 'primary.main' }}>
              Thank You!
            </Typography>
            <Typography variant="body1" sx={{ mb: 4 }}>
              You've successfully signed up for our newsletter. Watch your inbox for exclusive deals and updates!
            </Typography>
            <Button variant="contained" onClick={() => navigate('/')}>
              Back to Home
            </Button>
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                  Your Information
                </Typography>
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name (optional)"
                />
              </Grid>
              
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  error={!!error}
                  helperText={error}
                />
              </Grid>
              
              <Grid item xs={12}>
                <Divider sx={{ my: 2 }} />
                <Typography variant="h5" gutterBottom>
                  Interests
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Select the topics you're interested in (optional)
                </Typography>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={interests.basketball}
                      onChange={handleInterestChange}
                      name="basketball"
                    />
                  }
                  label="Basketball Cards"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={interests.football}
                      onChange={handleInterestChange}
                      name="football"
                    />
                  }
                  label="Football Cards"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={interests.baseball}
                      onChange={handleInterestChange}
                      name="baseball"
                    />
                  }
                  label="Baseball Cards"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={interests.boxes}
                      onChange={handleInterestChange}
                      name="boxes"
                    />
                  }
                  label="Hobby Boxes"
                />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={interests.deals}
                      onChange={handleInterestChange}
                      name="deals"
                    />
                  }
                  label="Special Deals"
                />
              </Grid>
              
              <Grid item xs={12} sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  fullWidth
                  sx={{ py: 1.5 }}
                >
                  Sign Up for Updates
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Paper>
    </Container>
  );
};

export default SignupPage; 